module.exports = __webpack_public_path__ + "img/ico-dingyue.a7383f9e.jpg";